<template>
  <el-container>
    <el-header>
      <dara-topbar />
    </el-header>
    <el-main>
      <dara-container :size="containerSize">
        <div class="dara-single-content-layout">
          <div class="dara-single-content-layout__main">
            <slot name="content" />
          </div>
        </div>
      </dara-container>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'DaraSingleContentLayout',
  props: {
    containerSize: String,
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/variables/paddings';
@import '@/scss/bootstrap/container';
@import '@/scss/bootstrap/mixins';

.dara-single-content-layout {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  .dara-single-content-layout__main {
    width: 100%;
    padding-top: $padding-lg;

    @include media-breakpoint-down(md) {
      padding: $padding-lg;
    }
  }
}
</style>
